import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TextArea from 'antd/es/input/TextArea'
import Loader from '../pages/loader'
import { Select } from 'antd'
import { useMarkTelegramMutation } from '../../redux/apis/linkManagement/telegram/lMTelegramApiSlice'
import InsertionResultModal from '../../components/InsertionResultModal'

const TelegramMarking = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading }] = useMarkTelegramMutation()
  const [result, setResult] = useState(null)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      urls: '',
      status: '',
    },

    validationSchema: Yup.object({
      urls: Yup.string().required('Please Enter Urls'),
      status: Yup.string().required('Please Enter Report Status')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)

      const data = urls.map(url => ({
        url: url,
        service: 10,
        status: values.status,
      }))

      try {
        const res = await create(data)
        const raw = res?.data ?? res?.error?.data ?? {}
        const innerData = raw?.data ?? {}
        const errorsArray = raw?.errors ?? []
        const failedLinksDetail = errorsArray.reduce((acc, item) => {
          const url = typeof item === 'string' ? item : item?.url
          if (url) acc[url] = { error: item?.error ?? '' }
          return acc
        }, {})
        const resultData = {
          success: raw?.success,
          message: raw?.message,
          new_links: innerData.marked_links ?? 0,
          existing_links: innerData.existing_links ?? 0,
          failed_links: innerData.failed_links ?? 0,
          invalid_domains: 0,
          not_found_domains: [],
          failed_links_detail: failedLinksDetail
        }
        setResult(resultData)
        if (raw?.success) {
          validation.resetForm()
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div>
      <Loader isLoading={isLoading} />
      <InsertionResultModal
        result={result}
        reportTitle='Telegram URL marking'
        onClose={() => setResult(null)}
      />
      <Card>
        <CardHeader>
          <p>Telegram Link Marking</p>
        </CardHeader>
        <CardBody>
          <div className=' mb-3'>
            <label className="form-label">Report Status</label>
            <br />
            <Select
              name='status'
              className={'customSelect'}
              style={{
                width: '100%'
              }}
              onBlur={validation.handleBlur}
              onChange={e => {
                validation.setFieldValue('status', e)
              }}
              value={validation.values?.status}
              options={[
                { label: 'Related', value: 'related' },
                { label: 'UnRelated', value: 'unrelated' },
                { label: 'Reported', value: 'reported' },
                { label: 'Removed', value: 'removed' },
                { label: 'Reported Removed', value: 'reported_removed' }
              ]}
            />
          </div>
          {validation.touched.status && validation.errors.status ? (
            <p className='text-danger'>{validation.errors.status}</p>
          ) : null}
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default TelegramMarking
